<template>
  <div class="ga-container d-block pb-5">
    <div class="row justify-content-center">
      <div class="col-xl-7 col-12 mb-5">
        <div class="w-100 radius-12 bg-white box-shadow-light-aff border-semi-grey px-4 pb-4 pt-5 mb-5" >
          <div v-if="pageStatus.isLoad" class="w-100 py-4">
            <loader />
          </div>
          <template v-else>
            <div class="w-100 pt-4" v-if="pageStatus.error">
              <ErrorMessage :message="pageStatus.error"></ErrorMessage>
            </div>
            <div v-else class="w-100">

              <!-- PAYMENT SUCCESS -->
              <div
                class="mb-5 text-center"
                v-if="paymentDetail.status == 'SUCCESS' || paymentDetail.status == 'PAY_LATER'" >
                <img
                  src="../../../assets/img/icon/green-checked-2.png"
                  class="mb-4 img-check" />
                <p class="heading-5-2 text-green mb-0 text-uppercase">
                  {{ $t("ticket.your-booking-complete") }}
                </p>
                <p class="mb-0 body-2-2-1 mb-1">
                  {{ $t("ticket.thanks-for-order") }}
                </p>
                <p class="mb-0 body-2-4 mb-3">Invoice : {{ transactionDetail.invoice }}</p>
                <p class="mb-4 text-24 font-lato text-ticket">
                  {{ $formatCurrency(transactionDetail.total_payment) }}
                </p>
                <router-link :to="'/'+getMerchant.code+'/booking'">
                  <button type="button" class="button-primary bg-white text-black border px-4 w-195px mx-2 mb-3">Explore More Experience</button>
                </router-link>
              </div>
              
              <!-- PAYMENT PENDING -->
              <div class="mb-5" v-if="paymentDetail.status === 'PENDING' || paymentDetail.status === 'UNPAID'">
                <div class="mb-5 text-center">
                  <img src="../../../assets/img/icon/pending2.png" class="mb-4 img-check">
                  <template v-if="paymentDetail.status === 'UNPAID'">
                    <p class="heading-5-2 text-warning mb-0 text-uppercase">Waiting For Your Payment</p>
                    <p class="mb-0 body-2-2-1 mb-1">Please proceed with the payment to complete your booking</p>
                    <p class="mb-0 body-2-4 mb-3">Invoice : {{ transactionDetail.invoice }}</p>
                  </template>
                  <template v-else>
                    <p class="heading-5-2 text-warning mb-0 text-uppercase">Waiting Confirmation</p>
                    <p class="mb-0 body-2-2-1 mb-1">Please wait, your booking is being checked</p>
                    <p class="mb-0 body-2-4 mb-3">Invoice : {{ transactionDetail.invoice }}</p>
                  </template>
                </div>
                
                <template v-if="paymentDetail.status === 'UNPAID'">
                  <!-- VA / DIRECT BANK TRANSFER -->
                  <div class="d-flex justify-content-center">
                    <div style="max-width: 350px;">
                      <VirtualAccount
                        v-if="paymentDetail.payment_channel.payment_method == 'VIRTUAL_ACCOUNT' || paymentDetail.payment_channel.payment_method == 'BANK_TRANSFER'"
                        :data="paymentDetail"
                        module_page="HOTEL_UPSELLING" />
                    </div>
                  </div>
  
                  <!-- QRIS -->
                  <div v-if="paymentDetail.payment_channel.payment_method == 'QRIS'" class="d-flex justify-content-center">
                    <div style="max-width: 350px;">
                      <Qris 
                        :data="paymentDetail"
                        module_page="HOTEL_UPSELLING"
                        :customer_detail="customerDetail" />
                    </div>
                  </div>
                  
                  <!-- XENDIT CC FORM -->
                  <XenditInputCC
                    v-if="paymentDetail.showXenditCCForm"
                    :tx_payment="paymentDetail.payment_details"
                    module_page="BOOKING_ENGINE"
                    submodule_page="BE_ADDITIONAL_SERVICE"
                    @done="initPage"
                    @done-destroyed="initPage"
                    @expired="initPage">
                  </XenditInputCC>
                  
                </template>
                
                <div class="w-100 text-center" v-if="!paymentDetail.showXenditCCForm">
                  <button class="g-btn g-btn-secondary g-btn-lg mb-3" v-if="paymentDetail.payment_channel.bank_name == 'DIRECT_PAYMENT' && paymentDetail.status === 'UNPAID'" @click="toggleConfirmPayment()">Confirm Payment</button>

                  <p v-if="paymentDetail.status === 'UNPAID'" class="body-2-4 mb-2">{{$t("hotel.waiting.already-made-a-payment")}}</p>
                  <state-button variant="primary-ticket" size="lg" :click="checkPaymentStatus">{{$t("hotel.waiting.check-payment-status")}}</state-button>
                </div>
              </div>

              <!-- PAYMENT CANCELLED -->
              <div class="text-center mb-4" v-if="paymentDetail.status === 'CANCELLED'">
                <img src="../../../assets/img/icon/cancel-red.png" class="mb-4 img-check">
                <p class="heading-5-2 text-warning mb-0 text-uppercase">Cancelled</p>
                <p class="mb-0 body-2-2-1 mb-1">This booking has been canceled. If this was a mistake, please make a new booking</p>
                <p class="mb-0 body-2-4 mb-3">Invoice : {{ transactionDetail.invoice }}</p>
                <router-link :to="'/'+getMerchant.code+'/booking'">
                  <button type="button" class="button-primary bg-white text-black border px-4 w-195px mx-2 mb-3">Explore More Experience</button>
                </router-link>
              </div>

              <!-- DETAIL TRANSACTION -->
              <div class="row mb-4">

                <!-- PRODUCT -->
                <div class="col-md-8 col-12 mb-4 mb-md-2">
                  <div class="w-100 border-form radius-6 h-100 position-relative" style="padding-bottom: 56.667px;">
                    <div class="p-3 border-b-form radius-t-6 position-relative">
                      <div class="row no-gutters z-index-1026">
                        <div class="col-8">
                          <p class="mb-0 body-1-4">Service</p>
                        </div>
                        <div class="col-4 text-right">
                          <p class="mb-0 body-1-4">{{ $t('ticket.price') }}</p>
                        </div>
                      </div>
                      <div class="primary-overlay z-index-1025"></div>
                    </div>
                    <div class="p-3">
                      <p class="mb-3 body-3-3" v-if="isProductShowServiceDate"><i>The service time is displayed in the property's local time: (UTC{{ getMerchantTimezone.offset }}) {{ getMerchantTimezone.name }}.</i></p>
                      <div class="row no-gutters" v-for="(product,productIndex) in productDetail" :class="{'mb-2 pb-2 border-b-form-dashed': productIndex+1 < productDetail.length }">
                        <div class="col-1 align-self-start">
                          <p class="mb-0 font-lato text-14">{{ product.qty }}X</p>
                        </div>
                        <div class="col-7 align-self-start">
                          <div class="pl-mobile">
                            <p class="mb-0 body-2-1">{{ product.name }}</p>
                            <ul class="pl-3" v-if="$isNotEmptyV2(product.moreInfo)">
                              <li class="mb-1" v-for="note in product.moreInfo">
                                <p class="mb-0 body-3-3">{{ `${note.title} : ${note.value}` }}</p>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div class="col-4 align-self-start text-right">
                          <p class="mb-0 font-lato text-14">{{ $formatCurrency(product.price) }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="p-3 border-t-form position-absolute w-100" style="bottom: 0;">
                      <div class="row no-gutters">
                        <div class="col-8">
                          <p class="mb-0 body-1-4">{{ $t('ticket.total') }}</p>
                        </div>
                        <div class="col-4">
                          <p class="mb-0 body-1-4 text-right">{{ $formatCurrency(Number(transactionDetail.total_payment)) }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- GUEST DETAIL -->
                <div class="col-md-4 col-12 mb-4 mb-md-2">
                  <div class="w-100 border-form radius-6 h-100">
                    <div class="p-3 border-b-form radius-t-6 position-relative">
                      <div class="row no-gutters z-index-1026">
                        <div class="col-12">
                          <p class="mb-0 body-1-4">{{ $t('ticket.guest-detail') }}</p>
                        </div>
                      </div>
                      <div class="primary-overlay z-index-1025"></div>
                    </div>
                    <div class="p-3">
                      <div class="row no-gutters">
                        <div class="col-12 mb-3" v-for="customerData in customerDetailList">
                          <div class="w-100 pr-3">
                            <p class="mb-0 body-3-3-1">{{ customerData.title }}</p>
                            <p class="mb-0 body-2-1">{{ customerData.value }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- NOTES -->
                <div class="col-12" v-if="$isNotEmptyV2(transactionDetail.notes)">
                  <div class="d-flex align-items-center">
                    <span class="mb-0 body-2-4 text-danger mr-1">*</span>
                    <span class="mb-0 body-2-4 mr-1">Your notes : </span>
                    <span class="mb-0 body-2"><i>{{ transactionDetail.notes }}</i></span>
                  </div>
                </div>

                <!-- PAYMENT -->
                <div class="col-12 mt-4" v-if="paymentDetail.status === 'SUCCESS' || paymentDetail.status === 'CANCELLED' || paymentDetail.status === 'PAY_LATER'">
                  <div class="w-100 border-form radius-6 h-100">
                    <div class="p-3 border-b-form radius-t-6 position-relative">
                      <div class="row no-gutters z-index-1026">
                        <div class="col-12">
                          <p class="mb-0 body-1-4">{{ $t('ticket.payment-detail') }}</p>
                        </div>
                      </div>
                      <div class="primary-overlay z-index-1025"></div>
                    </div>
                    <div class="p-3">
                      <div v-if="paymentDetail.status === 'PAY_LATER'">
                        <p class="mb-0 body-2-1">This booking uses PAY LATER</p>
                      </div>
                      <template v-else>
                        <template v-for="(paymentDetailItem, paymentDetailIndex) in paymentDetail.display">
                          <div class="row">
                            <div class="col-lg-4 col-5">
                              <p class="mb-0 body-2-1">{{ paymentDetailItem.title }}</p>
                            </div>
                            <div class="col-lg-8 col-7 text-right">
                              <p class="mb-0 body-2-1" :class="paymentDetailItem.styleClass">{{ paymentDetailItem.value }}</p>
                            </div>
                          </div>
                          <div v-if="paymentDetailIndex + 1 < paymentDetail.display.length" class="w-100 my-3 border-t-d-secondary-t"></div>
                        </template>
                      </template>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>


    <popup-detail 
      direction="bottom" 
      :show="showPaymentConfirm"
      wrapper_size="mobile"
      title="Confirm your payment"
      @close="toggleConfirmPayment">
      <template v-slot:body>
        <div class="p-4 border-t-semi-grey">
          <PaymentConfirm ref="payment_confirm" v-if="showPaymentConfirm" :tx_order_id="transactionId" @close="toggleConfirmPayment"></PaymentConfirm>
        </div>
      </template>
    </popup-detail>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from "vuex";
import { get, post } from "@/services/index.js";
import VirtualAccount from '@/components/general/payment/VirtualAccount'
import Qris from '@/components/general/payment/Qris'
import PaymentConfirm from '@/components/general/payment/PaymentConfirm'
import XenditInputCC from '@/components/hotel/be/XenditInputCC';

export default {
  components:{
    VirtualAccount,
    Qris,
    PaymentConfirm,
    XenditInputCC
  },
  data() {
    return {
      pageStatus: {
        isLoad: true,
        error: ""
      },
      transactionDetail: {},
      showPaymentConfirm: false
    };
  },
  computed: {
    ...mapGetters(["getMerchant", "getMerchantTimezone"]),
    transactionId() {
      return this.$isNotEmptyV2(this.$route.params.tx_order_id)
        ? this.$route.params.tx_order_id
        : "";
    },
    showDetailTransaction() {
      if (this.$isEmpty(this.transactionDetail.tx_bill_list)) return false;

      const payment = this.transactionDetail.tx_bill_list[0];
      return payment.status === "SUCCESS";
    },
    isPaymentComplete() {
      if (this.$isEmpty(this.transactionDetail.tx_bill_list)) return false;

      const payment = this.transactionDetail.tx_bill_list[0];
      return payment.status === "SUCCESS" || payment.status === "CANCELLED";
    },
    paymentDetail() {
      if (this.$isEmpty(this.transactionDetail.tx_bill_list)) return {status: "PAY_LATER"};
      let paymentData = this.transactionDetail.tx_bill_list[0];
      if(this.$isEmpty(paymentData.payment_details) && this.$isNotEmptyV2(paymentData.inq_resp_detail)){
        paymentData.payment_details = JSON.parse(paymentData.inq_resp_detail).payment
      }
      const {payment_method, bank_name } = paymentData.payment_channel
      if(payment_method === 'QRIS' && bank_name === 'XENDIT'){
        paymentData.payment_details.ch_ref1 = `data:image/png;base64,${paymentData.payment_details.qr_image}`;
        paymentData.payment_details.expired_date_utc = moment(paymentData.payment_details.expired_date).utc().format();	
      }

      paymentData.showXenditCCForm = this.showXenditCreditCardForm(paymentData);
      if(paymentData.showXenditCCForm){
        paymentData.payment_details.tx_order_id_2 = paymentData.tx_invoice_id
      }
      
      let displayList = []
      const addDisplayList = (title, value, styleClass='') => displayList.push({ title, value, styleClass });

      const { payment_channel: { name } , status, total_paid, created_at, payment_surcharge	 } = paymentData
      addDisplayList(this.$t('ticket.payment-method'), name);
      addDisplayList(this.$t('ticket.payment-time'), this.$formatDateTime(created_at));
      if(Number(payment_surcharge) > 0){
        addDisplayList(this.$t('ticket.payment-surcharge'), this.$formatCurrency(payment_surcharge));
      }
      addDisplayList(this.$t('ticket.total-paid'), this.$formatCurrency(total_paid));
      let statusColor = () => {
        let statusData = { style:'', text: '' };
        switch (status) {
          case 'SUCCESS':
            statusData = { style:'text-success', text: this.$t('ticket.success') }
            break;
          case 'CANCELLED':
            statusData = { style:'text-danger', text: this.$t('ticket.cancelled') }
            break;
          case 'PENDING':
            statusData = { style:'text-warning', text: 'PENDING' }
            break;
          default:
            statusData = { style:'text-dark', text: status }
            break;
        }
        statusData.style += " text-uppercase font-bold"
        return statusData;
      }
      addDisplayList(this.$t('ticket.payment-status'), statusColor().text, statusColor().style);

      paymentData.display = displayList;
      return paymentData;
    },
    customerDetailList() {
      if (this.$isEmpty(this.transactionDetail.tx_order_list)) return [];
      const { first_name, last_name, email, phone_number } = this.transactionDetail.tx_order_list[0].customer_detail

      const customerData = [];
      const addCustomerData = (title,value) => customerData.push({ title, value });
      
      const fullNameValue = `${first_name} ${this.$isNotEmptyV2(last_name) ? last_name : ''}`;
      addCustomerData(this.$t('ticket.name'), fullNameValue);
      addCustomerData(this.$t('ticket.email'), email);
      addCustomerData(this.$t('ticket.phone-number'), phone_number);
      
      return customerData
    },
    customerDetail(){
      if (this.$isEmpty(this.transactionDetail.tx_order_list)) return {};
      return this.transactionDetail.tx_order_list[0].customer_detail;
    },
    productDetail(){
      if (this.$isEmpty(this.transactionDetail.tx_order_list)) return [];

      let productList = [];
      const addProductList = (qty, name, price, moreInfo=[]) => productList.push({ qty, name, price, moreInfo });

      this.transactionDetail.tx_order_list.forEach(productPos => {
        const { pos : { pos_type }, tx_detail_list } = productPos 

        tx_detail_list.forEach(product => {
          const isPosActivityOrSpa = pos_type === 'SPA' || pos_type === 'ACTIVITY';
          const { qty, product_name, variant_name, subtotal_sell, remark, notes = null, service_date = null } = product
          
          const productName = `${product_name} ${this.$isNotEmptyV2(variant_name) ? ` - ${variant_name}` : ''}`
          let note = []
          if(isPosActivityOrSpa){
            note.push({title: 'Service Date', value: this.$formatDateTime(service_date, true)})
          }
          if(this.$isNotEmptyV2(remark) || this.$isNotEmptyV2(notes)){
            if(isPosActivityOrSpa){

              const splitRemark = remark.split(',');
              splitRemark.forEach(remarkType => {
                const splitType = remarkType.split(":")
                if(this.$isNotEmptyV2(splitType[1])){
                  const activityRemark = {
                    title: splitType[0].trim(),
                    value: splitType[1].trim(),
                  }
                  const isTherapistRandom = activityRemark.title === 'Therapist gender' && activityRemark.value === 'Random'
                  if(!isTherapistRandom) note.push({title: splitType[0].trim(), value: splitType[1].trim()})
                }
              });
              
            }else{
              note.push({ title: 'Notes', value: this.$isNotEmptyV2(remark) ? remark : notes })
            }
          }
          
          addProductList(qty, productName, subtotal_sell, note)
        });
        
      });
      
      return productList;
    },
    isProductShowServiceDate(){
      if (this.$isEmpty(this.productDetail)) return [];
      return this.transactionDetail.tx_order_list.some(productPos => productPos.pos.pos_type === 'SPA' || productPos.pos.pos_type === 'ACTIVITY')
    }
  },
  mounted() {
    this.initPage();
  },
  methods: {
    backToSearchPage(){
      this.$router.push(`${this.getMerchant.code}/booking`)
    },
    toggleConfirmPayment(){
      let isPaymentConfirmExist = this.$refs.payment_confirm
      if(this.showPaymentConfirm && isPaymentConfirmExist && isPaymentConfirmExist.result_push == 'success'){
        this.getTransactionDetail()
      }
      this.showPaymentConfirm = !this.showPaymentConfirm
    },
    showXenditCreditCardForm(paymentDetail){
      const { status, payment_channel: { bank_name, payment_method } } = paymentDetail; 
      const isStatusUnpaid = status == 'UNPAID';
      const isPaymentCreditCard = payment_method == 'CREDIT_CARD'
      const isPaymentChannelXendit = bank_name == 'XENDIT' || bank_name== 'XENDIT_INTERNATIONAL'

      return isStatusUnpaid && isPaymentCreditCard && isPaymentChannelXendit;
    },
    async checkPaymentStatus(){
      try {
        await this.getTransactionDetail(false);
      } catch (error) {
        console.log("ERROR Checkin Payment : ", error);
      } finally {
        return Promise.resolve()
      }
    },
    async getTransactionDetail(isReset=true) {
      try {
        if(isReset) this.transactionDetail = {};

        const apiResponse = await get(
          "CORE_HOTEL",
          `merchant-pos/multiple/transaction/${this.transactionId}`,
          { merchant_id: this.getMerchant.id }
        );
        const { success, data, message } = apiResponse.data;
        if (!success) throw new Error(message);
        this.transactionDetail = data;
        if (this.isPaymentComplete) this.$emit("update-step", 4);
      } catch (error) {
        throw error;
      }
    },
    async initPage() {
      try {
        this.pageStatus = {
          isLoad: true,
          error: ""
        };

        await this.getTransactionDetail();
      } catch (error) {
        this.pageStatus.error = error;
      } finally {
        this.pageStatus.isLoad = false;
      }
    }
  }
};
</script>
<style>
  .img-check{
    height: 100px;    
  }
  @media screen and (max-width: 400px){
    .img-check{
      height: 60px;    
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/hotel/be/BePaymentResultAdditionalService.vue